// "Your photos": what the actor already has in the PM API, to pick instead of uploading. Shown
// only when there is something to pick. Choosing one uploads nothing and changes nothing in the
// library. Resumes have their own picker (ResumePicker.tsx).

import React from "react";
import styled, { css } from "styled-components";
import i18next from "i18next";
import { IMediaAssetDto } from "../../../shared/api/submission/types";
import { MEMBERSHIP_BLUE } from "./membershipButton";

interface PhotosProps {
  photos: IMediaAssetDto[];
  selectedId?: number;
  onPick: (photo: IMediaAssetDto) => void;
}

export const PhotoLibrary: React.FC<PhotosProps> = ({ photos, selectedId, onPick }) => {
  if (!photos.length) return null;
  return (
    <Section>
      <Heading>{i18next.t("Your photos")}</Heading>
      <Strip role="group" aria-label={i18next.t("Your photos")}>
        {photos.map((p) => (
          <Thumb
            key={p.assetId}
            type="button"
            selected={p.assetId === selectedId}
            aria-pressed={p.assetId === selectedId}
            aria-label={i18next.t("Choose photo {{number}}", { number: p.assetId })}
            onClick={() => onPick(p)}
          >
            {p.url ? <ThumbImage src={p.url} alt="" /> : <ThumbFallback>{p.assetId}</ThumbFallback>}
          </Thumb>
        ))}
      </Strip>
    </Section>
  );
};

const Section = styled.div`
  width: 100%;
  margin: 12px 0 4px;
`;

const Heading = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #53627c;
  margin-bottom: 8px;
`;

const Strip = styled.div`
  display: flex;
  overflow-x: auto;
  padding: 2px 2px 4px;

  > * + * {
    margin-left: 8px;
  }
`;

const selectedRing = css`
  box-shadow: 0 0 0 2px ${MEMBERSHIP_BLUE.normal};
`;

const Thumb: any = styled.button`
  flex: 0 0 auto;
  width: 56px;
  height: 70px;
  padding: 0;
  border: 1px solid #c9d3e0;
  border-radius: 6px;
  overflow: hidden;
  background: #f7f9fb;
  cursor: pointer;
  ${(p: any) => p.selected && selectedRing}

  &:focus-visible {
    outline: 2px solid #0f9bf0;
    outline-offset: 2px;
  }
`;

const ThumbImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const ThumbFallback = styled.span`
  font-size: 12px;
  color: #8a94a6;
`;
